import {Discount} from 'services/entities/discounts';
import {callAPI} from 'services/api';
import {getCacheItem, setCacheItem} from 'util/cache';

const DISCOUNT_CACHE_KEY_PREFIX = 'discount.';


export function readDiscount(data: any) : Discount {
  return {
    code: data.code,
    description: data.description,
    rate: parseFloat(data.rate)
  };
}

export async function loadDiscounts(discounts:Discount[]|string[]): Promise<Discount[]> {
  if(discounts.length === 0) {
    return [];
  }
  if(typeof(discounts[0]) === 'string') {
    const discountCodes = discounts as string[];
    return Promise.all(discountCodes.map(d => loadDiscount(d)));
  } else {
    return discounts as Discount[];
  }
}

export async function loadDiscount(code: string): Promise<Discount> {
  let discount = getCacheItem(DISCOUNT_CACHE_KEY_PREFIX + code.toLowerCase());
  if(discount) {
    return discount;
  }
  const response = await callAPI(`/discounts/${code}/`, 'GET', null, true);
  discount = readDiscount(response);
  setCacheItem(DISCOUNT_CACHE_KEY_PREFIX + code.toLowerCase(), discount);
  return discount;
}

export async function validateDiscount(code: string): Promise<Discount> {
  const response = await callAPI(`/discounts/${code}/validate/`, 'GET', null, true);
  return readDiscount(response);
}